<template>
    <div class="single-proposal-logs">
        <h2>История заявки</h2>
        <div
            class="items"
            ref="items"
        >
            <SingleLog
                v-for="item in proposalLogs"
                :key="item.createTime"
                :item="item"
            ></SingleLog>
        </div>
    </div>
</template>

<script>
import SingleLog from "./SingleLog";
import {mapGetters} from "vuex";

export default {
    components: {
        SingleLog,
    },
    computed: {
        ...mapGetters('proposals', [
            'proposalLogs',
        ]),
    },
    watch: {
        proposalLogs() {
            this.$refs.items.scrollTop = 0;
        },
    },
};
</script>

<style lang="scss" scoped>
    @import '../../../styles/rem';


    .single-proposal-logs {
        margin-bottom: rem(40);

        h2 {
            margin-bottom: 0;

            @include on-mobile {
                margin-bottom: mrem(16);
            }
        }

        .items {
            @include custom-scroll-bar;
            max-height: rem(300);
            overflow-y: scroll;
            border-radius: rem(4);
            border: 1px solid #FFFFFF;
            padding: 0 0 rem(8);

            @include on-mobile {
                max-height: 40vh;
                border-radius: mrem(4);
                padding: 0 0 mrem(8);
            }
        }
    }
</style>
